// extracted by mini-css-extract-plugin
export default {"name":"ProfileLayout_name__a2W-Z"};